module.exports = __webpack_public_path__ + "static/img/net-border-3.bc2f3160.png";